import { render } from "./InputDownloadSubmitForm.vue?vue&type=template&id=023ea4fc"
import script from "./InputDownloadSubmitForm.vue?vue&type=script&lang=js"
export * from "./InputDownloadSubmitForm.vue?vue&type=script&lang=js"

import "./InputDownloadSubmitForm.vue?vue&type=style&index=0&id=023ea4fc&lang=scss"

import exportComponent from "/Users/pavel/FrontReportTechnomoscow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__